import type { Item } from "./infra";

// Strip the digest before finding the tag separator; registry ports are not tags.
export function imageReferences(image: Item): { name: string; version: string }[] {
  const parse = (reference: unknown) => {
    const value = String(reference || "").trim();
    if (!value || value.includes("<none>") || /^(sha256:)?[a-f0-9]{64}$/i.test(value)) return null;
    const repository = value.split("@")[0];
    const colon = repository.lastIndexOf(":");
    const tagged = colon > repository.lastIndexOf("/");
    const name = tagged ? repository.slice(0, colon) : repository;
    if (!name) return null;
    return { name, version: tagged ? repository.slice(colon + 1) : "버전 미지정" };
  };
  const tags = (image["refs"] || []).map(parse).filter(Boolean);
  const names = new Set(tags.map((ref: { name: string }) => ref.name));
  const digests = (image["repoDigests"] || []).map(parse).filter(
    (ref: { name: string } | null) => ref && !names.has(ref.name),
  );
  const references = [...tags, ...digests];
  if (!references.length) {
    const fallback = parse(image["reference"] || image["ref"]);
    if (fallback) references.push(fallback);
  }
  return [...new Map<string, { name: string; version: string }>(
    references.map(ref => [ref.name + "\0" + ref.version, ref]),
  ).values()];
}

export function imageName(image: Item): string {
  return image["name"] || [...new Set(imageReferences(image).map(ref => ref.name))].join(", ") || "이름 없는 이미지";
}

export function imageVersions(image: Item): string {
  return [...new Set(imageReferences(image).map(ref => ref.version))].join(", ") || "버전 미지정";
}
